import { WegicRequest } from '@wegic/request';
import { Message } from '@wegic/ui';
import { getErrorMessage } from './error';

/**
 * 创建用户请求实例
 */
export function createUserRequest(baseURL: string = '/api/user/v1') {
  return WegicRequest({
    baseURL,
    hideCodeErrorMessage: false,
    hideHTTPErrorMessage: false,
    withCredentials: true,
    errorHandler: {
      onHttpError: (context: any) => {
        if (context?.config?.hideHTTPErrorMessage) {
          return;
        }
        const message = context.key ? getErrorMessage(context.key) : context.message;
        message && Message.error(message);
      },
      onBusinessError: (context: any) => {
        if (context?.config?.hideCodeErrorMessage) {
          return;
        }
        const message = context.key ? getErrorMessage(context.key) : context.message;
        message && Message.error(message);
      },
    },
  });
}

/**
 * 用户请求
 */
export const userRequest = createUserRequest();
